import StoreModuleService from '../StoreModuleService';
import { getServiceBySlug } from '../apps/getters';
import { MODULE_NAME } from './const';

const buildContextGetterObject = (getter) => StoreModuleService.buildGetterObject(MODULE_NAME, getter);

// getters declarations
export const contextFetchingLoading = buildContextGetterObject('contextFetchingLoading');
export const getAllContexts = buildContextGetterObject('getAllContexts');
export const getServiceContexts = buildContextGetterObject('getServiceContexts');
export const getContext = buildContextGetterObject('getContext');
export const getServiceContextsBySlug = buildContextGetterObject('getServiceContextsBySlug');
export const getContextsByKey = buildContextGetterObject('getContextsByKey');

const getters = {
	[getAllContexts.getter]: (state) => Object.values(state.data),
	[getServiceContexts.getter]: (state, getters) => (serviceId) =>
		getters[getAllContexts.getter].filter((context) => context.service === serviceId),
	[getContext.getter]: (state) => (contextId) => state.data[contextId],
	[contextFetchingLoading.getter]: (state) => state.contextFetchingLoading,
	[getServiceContextsBySlug.getter]: (state, getters, rootState, rootGetters) => (serviceSlug) =>
		getters[getServiceContexts.getter](rootGetters[getServiceBySlug.fullPath](serviceSlug)?.id),
	[getContextsByKey.getter]: (state, getters) => (key) => getters[getAllContexts].filter((context) => context.key === key),
};

export default getters;
